export const routes = {
  all: "*",
  homepage: "/",
  login: "/login",
  adminLogin: "/admin-login",
  registration: "/registration",
  courses: "/courses",
  courseModule: "/courses/modules",
  moduleViewing: "/courses/modules-viewing",
  test: "/test",
  actualTest: "/test/actualTest",
};

export const apiEndpoints = {
  login: "/login",
  logout: "/logout",
  courseList: "/admin/course-list",
  psrRegistration: "/admin/psr-registration",
  sendOTP: "/send-otp",
  verifyOTP: "/verify-otp",
  courseListUser: "/user/course-list-user",
  courseModuleListUser: "/user/course-module-list-user",
};
